import styled from '@emotion/styled';
import React from 'react';

import colors from 'config/theme/colors';
import settings from 'modules/notifications/data/settings';

const Circle = styled.div`
  border: solid 1px ${colors['@primary-color']};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: ${colors['@primary-color']};
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  position: relative;
  flex-shrink: 0;
  margin-right: 18px;
`;

/**
 * @param {import('modules/notifications/types').Notification} notification
 * @return {[icon:string]}
 */
export const getIconography = notification => {
  const { eventType, extension } = notification;
  const definition = settings[extension]?.[eventType];
  const { icon } = definition?.ui?.(notification) ?? {};
  return [icon ?? 'int-reminder'];
};

/**  @type {React.FC<{{ icon?: string | React.ReactNode }}>}  */
const Iconography = ({ icon }) => {
  const isFBIcon = typeof icon === 'string';
  return (
    <Circle>
      {isFBIcon ? <i className={`fb-icon--${icon}`} /> : icon}
    </Circle>
  );
};

export default Iconography;
